export default "__VITE_ASSET__LUDFBpeu__"